import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Autoplay, Navigation } from "swiper/modules"

// Connects to data-controller="swiper"
export default class extends Controller {
  static values = { index: { type: Number, default: 0 } }
  static targets = ["next", "prev", "pagination", "scrollbar"]

  connect() {
    const scrollbar = this.hasScrollbarTarget ? { el: this.scrollbarTarget, draggable: true } : {}
    const pagination = this.hasPaginationTarget ? { el: this.paginationTarget, clickable: true } : {}

    const swiper = new Swiper(this.element, {
      modules: [Navigation, Autoplay],
      loop: true,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      initialSlide: this.indexValue,
      scrollbar: scrollbar,
      pagination: pagination,
      navigation: {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
      },
    })
  }
}